import cx from 'clsx';
import { IFooterProps } from '@paylink/types';

import { PhonePeBrand } from '@shared/components/common';

const Footer = ({ isMobile }: IFooterProps) => (
	<div
		className={cx(
			'd-flex items-center justify-center gap2 width100  px4  ',

			{
				'py6 border-top1 border-grey2 bg-white': !isMobile,
				'py3 bg-white': isMobile,
			},
		)}
	>
		<PhonePeBrand />
	</div>
);

export default Footer;
